import { BillVote } from '@enview/interface/types/bills/BillVote';
import { ReactElement } from 'react';
import VoteIcon from '../../Icons/VoteIcon';
import { ActivityCard, ActivityCardStyle } from './ActivityCard';
import './ActivityCard.scss';

type BillVoteActivityCardProps = {
  billVote: BillVote;
};

const VoteActivityCard = (props: BillVoteActivityCardProps): ReactElement => {
  const { billVote } = props;

  const date = new Date(billVote.startDate).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'utc',
  });

  const voteTitleContent = (
    <div className="vote-title">
      <div>
        <span>{billVote.motion ?? 'FLOOR VOTE'}</span>
        <div
          className={`badge toggle vote-result-toggle ${billVote.result?.toLowerCase()}`}
        >
          <span>{billVote.result}</span>
        </div>
      </div>
      <span className="chamber">{billVote.agency}</span>
    </div>
  );

  return (
    <ActivityCard
      activityStyle={ActivityCardStyle.BILL_VOTE}
      icon={<VoteIcon />}
      iconColor="teal"
      pretitle={date}
      title={<div>{voteTitleContent}</div>}
    />
  );
};

export default VoteActivityCard;
